import React from "react";
import { strings } from "./localization-context";
import IconSetting from "assets/icon_config_switch_lighting-1.svg";
import IconSettingLight from "./assets/img_light_theme/icon_config_switch_lighting-1.svg";
import IconChroma from "./assets/logo_chromastudio.svg";
import IconLaunch from "assets/icon_config_launch.svg";
import IconLaunchLight from "./assets/img_light_theme/icon_config_launch.svg";
import IconMultiMedia from "assets/icon_config_multimedia.svg";
import IconMultiMediaLight from "assets/img_light_theme/icon_config_multimedia.svg";
import IconPowerOff from "assets/icon_device_off.svg";
import IconPowerOffLight from "assets/img_light_theme/icon_device_off.svg";

/**
 * @example
 * iconSrc
 * title
 * subTitle
 * expandText
 * list
 */
export var razerSkill = function () {
  return {
    title: strings.synapseSkill,
    subtitle: strings.synapseSkillDetail,
    skills: [
      {
        title: strings.synapseSkill1,
        subtitle: strings.synapseSkillDetail1,
        content: [
          {
            index: 1,
            iconSrc: IconSetting,
            iconSrcLight: IconSettingLight,
            title: strings.basicLightingControls,
            subTitle: strings.basicLightingControlsDetail1,
            expandText: strings.expandText,
            closeText: strings.closeText,
            list: [
              strings.basicLightingControlsDetail1,
              strings.basicLightingControlsDetail2,
            ],
          },
          {
            index: 2,
            iconSrc: IconChroma,
            iconSrcLight: IconChroma,
            title: strings.chromaLightingControls,
            subTitle: strings.chromaLightingControlsDetail3,
            expandText: strings.expandText,
            closeText: strings.closeText,
            list: [
              strings.chromaLightingControlsDetail1,
              strings.chromaLightingControlsDetail2,
              strings.chromaLightingControlsDetail3,
              strings.chromaLightingControlsDetail4,
              strings.chromaLightingControlsDetail5,
            ],
          },
          {
            index: 3,
            iconSrc: IconLaunch,
            iconSrcLight: IconLaunchLight,
            title: strings.LaunchApplication,
            subTitle: strings.LaunChApplicationSubTitle,
            expandText: strings.expandText,
            closeText: strings.closeText,
            list: [strings.launchApplicationDetail1],
          },
          {
            index: 4,
            iconSrc: IconMultiMedia,
            iconSrcLight: IconMultiMediaLight,
            title: strings.MultimediaControls,
            subTitle: strings.MultimediaControlsDetail1,
            expandText: strings.expandText,
            closeText: strings.closeText,
            list: [
              strings.MultimediaControlsDetail1,
              strings.MultimediaControlsDetail2,
              strings.MultimediaControlsDetail4,
              strings.MultimediaControlsDetail3,
            ],
          },
          {
            index: 5,
            iconSrc: IconPowerOff,
            iconSrcLight: IconPowerOffLight,
            title: strings.PowerControls,
            subTitle: strings.PowerControlsDetail,
            expandText: strings.expandText,
            closeText: strings.closeText,
            list: [],
          },
        ],
      },
      {
        title: strings.synapseSkill2,
        subtitle: strings.synapseSkillDetail2,
        content: [
          {
            index: 1,
            iconSrc: IconPowerOff,
            iconSrcLight: IconPowerOffLight,
            title: strings.smartHomeSkillsControls,
            subTitle: strings.smartHomeSkillsControlsDetail,
            expandText: strings.expandText,
            closeText: strings.closeText,
            list: [
              strings.smartHomeSkillsControlsDetail1,
              strings.smartHomeSkillsControlsDetail2,
              strings.smartHomeSkillsControlsDetail3,
              strings.smartHomeSkillsControlsDetail4,
              strings.smartHomeSkillsControlsDetail5,
            ],
          },
        ],
      },
    ],
  };
};

export const RazerSkillContext = React.createContext(razerSkill);
